import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { apiHandle } from "../../config/apiHandle/apiHandle";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { themeOrange } from "../../utils/colorTheme";

const ContractRequiredDialog = () => {
  const [open, setOpen] = useState(false);
  const [signUrl, setSignUrl] = useState("/contract");
  const [onLogin, setOnLogin] = useState(false);
  const navigate = useNavigate();
  const { userAuth } = useSelector((state) => state.userAuth);
  const checked = useRef(false);

  // After logging in: go back to the page they were trying to open, and ask
  // pros who haven't signed the provider agreement to sign it now — before
  // a job comes in, not when they try to accept one.
  useEffect(() => {
    if (!userAuth) { checked.current = false; return; }
    let next = null;
    try { next = sessionStorage.getItem("dra_after_login"); sessionStorage.removeItem("dra_after_login"); } catch (e) { /* fine */ }
    if (next && next !== window.location.pathname + window.location.search) navigate(next);
    if (checked.current || localStorage.getItem("user_role") !== "2") return;
    checked.current = true;
    if ((next || window.location.pathname).includes("/contract")) return;
    apiHandle.get("/pro/contract/status").then((res) => {
      const signed = res?.data?.signed ?? res?.data?.data?.signed;
      if (signed === false) { setSignUrl("/contract"); setOnLogin(true); setOpen(true); }
    }).catch(() => {});
  }, [userAuth, navigate]);

  useEffect(() => {
    const handler = (e) => {
      setSignUrl(e.detail?.sign_url || "/contract");
      setOnLogin(false);
      setOpen(true);
    };
    window.addEventListener("app:contract-required", handler);
    return () => window.removeEventListener("app:contract-required", handler);
  }, []);

  const goSign = () => {
    setOpen(false);
    const path = signUrl.startsWith("/pro/") ? signUrl.replace("/pro", "") : signUrl;
    // After signing, bring them back to the job they were trying to accept.
    if (!onLogin) { try { sessionStorage.setItem("dra_after_sign", window.location.pathname + window.location.search); } catch (e) { /* fine */ } }
    navigate(path);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Sign the agreement first</DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "#444" }}>
          {onLogin
            ? "Sign the provider agreement once (it takes about a minute) so you can accept jobs the moment they come in."
            : "Before you can accept this you have to sign the agreement."}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={() => setOpen(false)} sx={{ color: "#666", textTransform: "none" }}>
          Not now
        </Button>
        <Button
          onClick={goSign}
          variant="contained"
          sx={{
            bgcolor: themeOrange,
            "&:hover": { bgcolor: "#C53F10" },
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Go to Provider Agreement
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContractRequiredDialog;
